import { render, staticRenderFns } from "./action-button.vue?vue&type=template&id=2ff82bc6"
import script from "./action-button.vue?vue&type=script&lang=js"
export * from "./action-button.vue?vue&type=script&lang=js"
import style0 from "./action-button.vue?vue&type=style&index=0&id=2ff82bc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports